import styled from '@emotion/styled'
import theme from '../../../../../styles/theme'
import {
  TextLarge500Style,
  InfoXXXLarge600Style,
  TextSmall500FadedStyle,
} from '../../../../../styles/Text.styles'

export const StyledKeyIndicators = styled.div`
  width: 100%;
`

export const IndicatorsWrapper = styled.div`
  display: flex;
  width: 100%;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
  gap: 0.625rem;
  flex-wrap: wrap;
`

export const Indicator = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${theme.colors.secondaryVeryVeryLight};
  text-align: center;
  justify-content: center;
  border-radius: 1.25rem;
  padding: 1.875rem 0.625rem;
  gap: 0.625rem;
  container-type: inline-size;

  /* On larger screens, show all 6 cards in one row */
  flex: 1;
  min-width: 150px; /* Prevent cards from becoming too narrow */

  /* On smaller screens, show 3 cards per row */
  @media (max-width: 1100px) {
    flex: 0 0 calc(33.333% - 0.625rem); /* Subtract the gap */
  }

  /* On very small screens, stack them vertically */
  @media (max-width: 600px) {
    flex: 0 0 100%;
  }
`

export const IndicatorLabel = styled.span`
  ${TextLarge500Style};
  flex-shrink: 0;
  white-space: nowrap;
`

export const IndicatorValue = styled.span`
  ${InfoXXXLarge600Style};
  font-weight: 700;
  font-size: clamp(1rem, 10cqw, 28px);
`

export const InfoText = styled.p`
  ${TextSmall500FadedStyle};
  margin-top: 1.5rem;
`
